import { Section, SpacedElements } from '@elfsight/lib-stripe-integration';
import { useLingui } from '@lingui/react/macro';
import { Title } from './title';

export function TotalAmountBlock({
  amount,
  color
}: {
  amount: string;
  color: string;
}) {
  const { t } = useLingui();

  return (
    <Section $color={color} $classModifier="total-amount" $withBottomDivider>
      <SpacedElements>
        <Title classModifier="label">{t`Total`}</Title>
        <Title classModifier="amount">{amount}</Title>
      </SpacedElements>
    </Section>
  );
}
